import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';

import LayoutBackend from '@/layouts/variations/Backend.vue';
import LayoutBackendNotFooter from '@/layouts/variations/BackendNotFooter.vue';

import { checkAuth, checkNiceId, isNoticeCookieAvailable, isBase64Encoded, handleRedirect } from '@/router/helpers.js';

Vue.use(Router);

const Main = () => import('@/views/NewMain/Main.vue');
const Rank = () => import('@/views/Rank.vue');

const Login = () => /* webpackChunkName: "group-mypage" */ import('@/views/My/Login.vue');
const Invitation = () => /* webpackChunkName: "group-mypage" */ import('@/views/My/Invitation.vue');

const Subscription = () => /* webpackChunkName: "group-subscription" */ import('@/views/Subscription/Subscription.vue');
const SubscriptionDetail = () => /* webpackChunkName: "group-subscription" */ import('@/views/Subscription/Detail.vue');

// const Land = () => import('@/views/Map/Land.vue');
const Map = () => import('@/views/Map/Layout/MapLayout.vue');

const Guide = () => import('@/views/Guide/Guide.vue');
const SwapGuide = () => import('@/views/Guide/SwapLaunching.vue');

const Unsubscribe = () => import('@/views/Negative/Unsubscribe.vue');
const NotFound = () => import('@/views/Negative/NotFound.vue');
// import web3Test from '@/views/Web3Test.vue';
const web3Test = () => /* webpackChunkName: "group-web3" */ import('@/views/Web3Test.vue');
// /store
const Store = () => /* webpackChunkName: "group-store" */ import('@/views/Store/Store.vue');

// /event
import { events } from '@/router/events.js';
// /my
import { mypage } from '@/router/mypage.js';
// /assets
import { assets } from '@/router/assets.js';
// /lotto
import { lotto } from '@/router/lotto.js';
// /community
import { community } from '@/router/community.js';
// mega-lotto
import { megaLotto } from '@/router/mega_lotto.js';
// pick-the-fate
import { pickTheFate } from '@/router/pick_the_fate.js';

// Router Configuration
const router = new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: '',
  scrollBehavior({ name }) {
    if (name?.includes('Lunar')) return;
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/redirect',
      name: 'Redirect',
    },
    {
      path: '/web3-test',
      name: 'web3Test',
      component: web3Test,
    },
    {
      path: '/',
      redirect: '/main',
      component: LayoutBackend,
      children: [
        {
          path: '/store',
          name: 'Store',
          component: Store,
          beforeEnter: checkAuth(),
        },
        {
          path: '/main',
          name: 'Main',
          component: Main,
          // component: Main,
          beforeEnter: checkAuth(),
        },
        {
          path: '/guide',
          name: 'Guide',
          component: Guide,
          beforeEnter: checkAuth(),
        },
        {
          path: '/guide/:tabIndex',
          name: 'GuideIndex',
          component: Guide,
          beforeEnter: checkAuth(),
        },
        {
          path: '/swapguide',
          name: 'SwapGuide',
          component: SwapGuide,
        },
        {
          path: '/rank',
          name: 'Rank',
          component: Rank,
          beforeEnter: checkAuth(),
        },
        {
          path: '/map',
          name: 'Land',
          component: Map,
          beforeEnter: checkAuth(),
        },
        ...megaLotto,
        ...pickTheFate,
      ],
    },
    {
      path: '/nice_id',
      children: [
        {
          path: 'done',
          beforeEnter: checkNiceId(true),
        },
        {
          path: 'fail',
          beforeEnter: checkNiceId(false),
        },
      ],
    },
    {
      path: '/subscription',
      component: LayoutBackend,
      children: [
        {
          path: '',
          name: 'Subscription information',
          component: Subscription,
          beforeEnter: checkAuth(),
        },
        {
          path: 'detail',
          name: 'Subscription Detail',
          component: SubscriptionDetail,
          beforeEnter: checkAuth(),
        },
      ],
    },
    // {
    //   path: '/property',
    //   component: LayoutBackend,
    //   children: [
    //     {
    //       path: '',
    //       name: 'Property',
    //       component: Property,
    //       beforeEnter: requireAuth(),
    //     },
    //     {
    //       path: 'history',
    //       name: 'History',
    //       component: PropertyHistoryConverter,
    //       beforeEnter: requireAuth(),
    //     },
    //     {
    //       path: 'detail',
    //       name: 'Detail',
    //       component: PropertyDetailMobile,
    //     },
    //   ],
    // },
    {
      path: '/login',
      component: LayoutBackendNotFooter,
      beforeEnter: (to, _, next) => {
        const redirectUri = to.query.redirect_uri;

        console.log('sign-in: redirectUri:', redirectUri);
        console.log('sign-in: isBase64Encoded:', isBase64Encoded(redirectUri));

        if (redirectUri === undefined || !isBase64Encoded(redirectUri)) {
          if (localStorage.getItem('redirectUri')) localStorage.removeItem('redirectUri');
          return next();
        }

        localStorage.setItem('redirectUri', redirectUri);

        return next();
      },
      children: [
        {
          path: '',
          name: 'Login',
          component: Login,
          beforeEnter: async (to, from, next) => {
            try {
              await store.dispatch('getLoginState');
              return next({ name: 'Main' });
            } catch {
              return next();
            }
          },
        },
      ],
    },
    {
      path: '/invitation',
      component: LayoutBackendNotFooter,
      children: [
        {
          path: '',
          name: 'Invitation',
          component: Invitation,
        },
      ],
    },
    {
      path: '/unsubscribe',
      name: 'Unsubscribe',
      component: Unsubscribe,
    },
    ...events,
    ...mypage,
    ...assets,
    ...lotto,
    ...community,
    // ...storeRouter,
  ],
});

router.onError((err) => {
  if (err.name === 'ChunkLoadError' || err.name === 'Error') location.reload(true);
});

router.beforeEach(async (to, from, next) => {
  console.log('beforeEach: store.state.lang', store.state.lang);
  if (to.name === 'Redirect') {
    handleRedirect();
    return next({ name: 'Main' });
  }

  // 유저 언어 설정
  if (store.state.lang === null) {
    try {
      await store.dispatch('fetchUserLang');
    } catch (e) {
      console.error(e);
    }
  }

  // to, from 라우트 이름
  const toName = to?.name;
  const fromName = from?.name;

  console.log('toName', toName);

  if (toName !== fromName) {
    (toName === 'Land' || toName === 'Subscription information') && store.dispatch('getHolidayName');
  }
  if (toName === 'Main') {
    const isNoticeCookie = isNoticeCookieAvailable();

    // 알반 공지
    if (isNoticeCookie) await store.dispatch('MainNoticeStore/getNotice');
    // 긴급 공지
    await store.dispatch('MainNoticeStore/getUrgentNotice');
  }

  const themeColor = toName === 'Main' ? '#000000' : undefined;

  store.dispatch('ThemeStore/updateThemeColor', themeColor);

  next();
});

router.afterEach((to, from) => {
  const fromName = from?.name;
  store.commit('setFromName', fromName);
  console.log('afterEach: fromName', fromName);
  console.log('afterEach: toName', to?.name);
});

export default router;
